import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import TimelapseIcon from "@mui/icons-material/Timelapse";
import { Button, Grid2 } from "@mui/material";
import { useTranslation } from "react-i18next";
import { zoullooColors } from "../../../../../theme";
import { TimeCommitmentViewModel } from "../../../../../ViewModels/FreelancerOnboardingMyAvailabilityStepViewModel";

interface TimeCommitmentButtonProps {
	readonly type: TimeCommitmentViewModel;
	readonly isSelected: boolean;
	readonly onClick: () => void;
	readonly size?: { xs: number; md: number };
}

export default function TimeCommitmentButton({
	type,
	isSelected,
	onClick,
	size = { xs: 12, md: 2 }
}: TimeCommitmentButtonProps) {
	const { t } = useTranslation();

	const getIcon = () => {
		return type === "fullTime" ? <RadioButtonCheckedIcon /> : <TimelapseIcon />;
	};

	const getLabel = () => {
		return type === "fullTime"
			? t("freelancerOnboardingMyAvailability.fullTime")
			: t("freelancerOnboardingMyAvailability.partTime");
	};

	return (
		<Grid2 size={size}>
			<Button
				startIcon={getIcon()}
				onClick={onClick}
				variant="outlined"
				size="large"
				disableRipple
				fullWidth
				sx={{
					color: zoullooColors.grey[700],
					borderColor: isSelected
						? zoullooColors.secondary?.main || "#6366f1"
						: zoullooColors.grey[400],
					borderWidth: isSelected ? 2 : 1,
					"&:hover": {
						borderColor: isSelected
							? zoullooColors.secondary?.main || "#6366f1"
							: zoullooColors.grey[700],
						backgroundColor: zoullooColors.grey[100]
					}
				}}
			>
				{getLabel()}
			</Button>
		</Grid2>
	);
}
